import {
	reReportHierarchyConstants
}from "./constants"
import {
	defAction
}from "../../../../helpers/defaultAction"
import api from "./api"

export const reReportHierarchyActions = {
	clear,
	createReportHierarchy,
	deleteReportHierarchy,
	getAllPaged,
	restoreReportHierarchy,
	updateReportHierarchy
}

function clear(){
	return (dispatch) => {
		dispatch(request())
		function request(){
			return {
				type: reReportHierarchyConstants.GetAllPaged.CLEAR
			}
		}
	}
}

function createReportHierarchy(values){
	const dispatchObj = {
		constants : reReportHierarchyConstants.CreateReportHierarchy,
		service   : {
			func   : api.createReportHierarchy,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteReportHierarchy(values){
	const dispatchObj = {
		constants : reReportHierarchyConstants.DeleteReportHierarchy,
		service   : {
			func   : api.deleteReportHierarchy,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getAllPaged(values){
	const dispatchObj = {
		constants : reReportHierarchyConstants.GetAllPaged,
		service   : {
			func   : api.getAllPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restoreReportHierarchy(values){
	const dispatchObj = {
		constants : reReportHierarchyConstants.RestoreReportHierarchy,
		service   : {
			func   : api.restoreReportHierarchy,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function updateReportHierarchy(values){
	const dispatchObj = {
		constants : reReportHierarchyConstants.UpdateReportHierarchy,
		service   : {
			func   : api.updateReportHierarchy,
			params : values
		}
	}
	return defAction(dispatchObj)
}
